export default __webpack_public_path__ + "static/media/HUD-Effects-00.7817d3de.jpg";